import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import StarRating from './StarRating/StarRating'

const Review = ({ rating, text, dark }) => {
  return (
    <div
      className={cn(
        'c-review flex flex-col justify-center items-center mb-24',
        {
          'c-review--dark': dark,
        }
      )}
    >
      <div className="pb-8">
        <StarRating rating={rating} />
      </div>
      <blockquote className="text-18 ml-0 pl-0 leading-normal">
        <p>“{text}”</p>
      </blockquote>
    </div>
  )
}

Review.propTypes = {
  rating: PropTypes.number,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  dark: PropTypes.bool,
}

Review.defaultProps = {
  rating: 5,
  text: '',
  dark: false,
}

export default Review
